import React, { memo } from 'react'
import { Col, Form, Select, Divider } from 'antd'
import PropTypes from 'prop-types'
import { hexToRGBA } from '../../../../../lib/utils'
import GoogleAddress from '../../../../../reusable-components/GoogleAddress'

const AddressDetailsSection = memo(({
  form,
  token,
  residentVisitor,
  setResidentVisitor,
  setCountry,
  countries,
  countriesLoading
}) => {
  return (
    <>
      <Col span={24}>
        <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          <Form.Item
            style={{ marginTop: 0, marginBottom: 0, width: 'calc(50% - 4px)', minWidth: 200 }}
            name='residentVisitor'
            label={<b style={{ fontSize: 15 }}>RSA Resident / Visitor</b>}
            rules={[{ required: true, message: 'Please if you are a RSA Resident or Visitor' }]}
          >
            <Select
              placeholder='RSA Resident or Visitor'
              options={[
                { label: 'RSA Resident', value: 'resident' },
                { label: 'Visiting From Abroad', value: 'visitor' }
              ]}
              defaultValue={residentVisitor}
              onChange={(value) => {
                if (value === 'resident') {
                  setCountry('ZA')
                }

                setResidentVisitor(value)
              }}
            />
          </Form.Item>
          {residentVisitor === 'visitor' ? (
            <Form.Item
              style={{ marginTop: 0, marginBottom: 0, width: 'calc(50% - 4px)', minWidth: 200 }}
              name='country'
              label={<b style={{ fontSize: 15 }}>Country of Residence</b>}
              rules={[{ required: true, message: 'Please provide your Country Of Residence' }]}
            >
              <Select
                showSearch
                optionFilterProp='label'
                loading={countriesLoading}
                placeholder='e.g South Africa'
                options={countries.map((e) => {
                  return {
                    label: e.name,
                    value: e.code
                  }
                })}
                onChange={(value) => {
                  setCountry(value)
                }}
              />
            </Form.Item>
          ) : undefined}
        </div>
      </Col>
      
      <Col span={24} style={{ marginTop: 24 }}>
        <Divider style={{ margin: '8px 0' }} />
      </Col>
      
      <Col span={24} style={{ marginTop: 16 }}>
        <Form.Item
          label={<b style={{ fontSize: 15 }}>Residential Address</b>}
          name='residentialAddress'
        >
          <GoogleAddress
            selectProps={{
              placeholder: form.getFieldValue('residentialAddress')
                ? form.getFieldValue('residentialAddress')
                : 'Residential Address',
              onChange: (e) => {
                form.setFieldValue('residentialAddress', e.label)
              }
            }}
          />
        </Form.Item>
      </Col>
    </>
  )
})

AddressDetailsSection.propTypes = {
  form: PropTypes.object.isRequired,
  token: PropTypes.object.isRequired,
  residentVisitor: PropTypes.string,
  setResidentVisitor: PropTypes.func.isRequired,
  setCountry: PropTypes.func.isRequired,
  countries: PropTypes.array.isRequired,
  countriesLoading: PropTypes.bool.isRequired
}

AddressDetailsSection.displayName = 'AddressDetailsSection'

export default AddressDetailsSection 